export default "__VITE_ASSET__99909b7f__"